// extracted by mini-css-extract-plugin
export default {"userInfo":"UserInfo_userInfo__FrvSh"};